(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[369],{

/***/ 8587:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event",
      function () {
        return __webpack_require__(1497);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_event; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(6383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./components/NewHeader/index.tsx + 19 modules
var NewHeader = __webpack_require__(614);
// EXTERNAL MODULE: ./components/About/index.ts + 12 modules
var About = __webpack_require__(5710);
// EXTERNAL MODULE: ./public/asset/blog/blog-main-visual.png
var blog_main_visual = __webpack_require__(7696);
// EXTERNAL MODULE: ./components/Common/CommonWrappers.tsx
var CommonWrappers = __webpack_require__(5564);
// EXTERNAL MODULE: ./components/Common/FloatingController.tsx
var FloatingController = __webpack_require__(1924);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(2587);
// EXTERNAL MODULE: ./components/Global/index.ts + 16 modules
var Global = __webpack_require__(6402);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(299);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(5351);
// EXTERNAL MODULE: ./public/asset/bluedot-metatag-img.png
var bluedot_metatag_img = __webpack_require__(2446);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/global-styles/index.ts
var global_styles = __webpack_require__(9059);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/assets/icons.tsx
var icons = __webpack_require__(1089);
// EXTERNAL MODULE: ../../node_modules/seamless-scroll-polyfill/lib/scroll.js + 1 modules
var lib_scroll = __webpack_require__(5378);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/breakPoints.ts
var breakPoints = __webpack_require__(3081);
// EXTERNAL MODULE: ../../packages/global-styles/MainButton.tsx
var MainButton = __webpack_require__(8920);
;// CONCATENATED MODULE: ./components/Common/CommonMainVisual.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "margin-top:56px;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var CommonMainVisual = /*#__PURE__*/ (0,react.memo)(function(param) {
    var backgroundImageSrc = param.backgroundImageSrc, innerContainerTitle = param.innerContainerTitle, descriptionTextComponent = param.descriptionTextComponent;
    var locale = (0,router.useRouter)().locale;
    var handleClickLearnMore = function() {
        var $heightContainer = document.querySelector(".main-section-container");
        if ($heightContainer) {
            (0,lib_scroll/* scrollTo */.X5)(window, {
                top: $heightContainer.getBoundingClientRect().height,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonMainVisualContainer, {
        className: "main-section-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonWrappers/* ImgBackgroundWrapper */.Yo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    // src={backgroundImg.src}
                    src: backgroundImageSrc,
                    layout: "fill",
                    alt: "bluedot blog",
                    className: "target-img",
                    objectFit: "cover",
                    sizes: "(min-width: 906px) 90vw, (min-width: 600px) 88vw, (max-width: 599px) 80vw",
                    loading: "eager",
                    quality: 30,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonWrappers/* MainVisualInnerContainer */.rO, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles.H1, {
                        className: "main-typo",
                        as: "h2",
                        children: locale === "en" ? innerContainerTitle.en : innerContainerTitle.ko
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "desc-text-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "anim-wrapper",
                            children: locale === "en" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: descriptionTextComponent.en
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: descriptionTextComponent.ko
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                        buttonType: "default-w",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AboutLearnMoreArrow */.wG, {}),
                        iconPosition: "right",
                        injectCssStyles: [
                            (0,breakPoints/* generateCssStyle */.m)({
                                "margin-top": "32px",
                                animation: "txtAnimation 0.8s 1.5s cubic-bezier(0.4, 0, 0.2, 1) backwards"
                            }),
                            breakPoints/* mediaQueryStyle.M */.Pm.M(_templateObject()), 
                        ],
                        injectInlineStyles: {
                            width: "328px",
                            height: "56px"
                        },
                        text: locale === "en" ? "Learn more" : "더 알아보기",
                        onClick: handleClickLearnMore
                    })
                ]
            })
        ]
    });
});
CommonMainVisual.displayName = "BlogMainVisual";
var CommonMainVisualContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* MainVisualOuterContainer */.XY).withConfig({
    displayName: "CommonMainVisual__CommonMainVisualContainer",
    componentId: "sc-d066c19d-0"
})(_templateObject1()); // const KO = () => (
 //   <div className="ko-wrapper">
 //     <SubtitleM>
 //       <div>
 //         미디어 트렌드 및 동영상 기술을 제공하는 블루닷의 노하우를 전합니다.
 //       </div>
 //     </SubtitleM>
 //   </div>
 // );
 // const EN = () => (
 //   <>
 //     <div className="en-wrapper-pc">
 //       <SubtitleM>
 //         <span>BLUEDOT is a startup that utilizes Semiconductor Design and</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>Deep Learning to provide Fast and Intelligent Video</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>
 //           Processing and Compression technologies through Cloud Data Center.
 //         </span>
 //       </SubtitleM>
 //     </div>
 //     <div className="en-wrapper-mo">
 //       <SubtitleM>
 //         <span>BLUEDOT is a startup that utilizes</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>Semiconductor Design and</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>Deep Learning to provide Fast and</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>Intelligent Video Processing and</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>Compression technologies through</span>
 //       </SubtitleM>
 //       <SubtitleM>
 //         <span>Cloud Data Center.</span>
 //       </SubtitleM>
 //     </div>
 //   </>
 // );

// EXTERNAL MODULE: ./components/Blog/BlogMainSection.tsx + 1 modules
var BlogMainSection = __webpack_require__(7406);
// EXTERNAL MODULE: ./components/Blog/CategoryTab.tsx
var CategoryTab = __webpack_require__(3951);
// EXTERNAL MODULE: ./context/EventContext.tsx
var EventContext = __webpack_require__(738);
;// CONCATENATED MODULE: ./components/Event/EventCategoryTab.tsx





var tabs = [
    {
        label: {
            en: "All",
            ko: "All"
        },
        value: "all"
    },
    {
        label: {
            en: "International",
            ko: "해외전시"
        },
        value: "international"
    },
    {
        label: {
            en: "Domestic",
            ko: "국내전시"
        },
        value: "domestic"
    }, 
];
var EventCategoryTab = function() {
    var locale = (0,router.useRouter)().locale;
    var ref = (0,EventContext/* useEventContext */.Z)(), type = ref.state.type, dispatch = ref.dispatch; // 전시 종류 필터
    var handleChangeEventType = function(type) {
        return dispatch({
            type: "change",
            newState: {
                type: type,
                currPageNum: 0
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTab/* CategoryTabContainer */.Nz, {
        children: tabs.map(function(tab) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTab/* TabItem */.E2, {
                isSelected: tab.value === type,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return handleChangeEventType(tab.value);
                    },
                    children: tab.label[locale]
                })
            }, tab.value);
        })
    });
};
/* harmony default export */ var Event_EventCategoryTab = (EventCategoryTab);

// EXTERNAL MODULE: ./components/Blog/NoPost.tsx
var NoPost = __webpack_require__(9120);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
;// CONCATENATED MODULE: ./components/Common/CommonSmallBadge.tsx




function CommonSmallBadge_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    "
    ]);
    CommonSmallBadge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CommonSmallBadge_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: #fff;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    "
    ]);
    CommonSmallBadge_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      background: #fff;\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 1.6rem;\n  border-radius: 4px;\n  min-height: 2.4rem;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  ",
        ";\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  padding: 2px 8px;\n  color: ",
        ";\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      background: #fafbfd;\n      border: 1px solid ",
        ";\n      cursor: not-allowed;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      cursor: pointer;\n      color: #00428e;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      svg {\n        transition: 0.2s all;\n        path {\n          fill: ",
        ";\n        }\n      }\n      &:hover {\n        background: #00234a;\n        color: #fff;\n\n        svg {\n          path {\n            fill: #fff;\n          }\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 1.6rem;\n  border-radius: 4px;\n  min-height: 2.4rem;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  transition: 0.2s all;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var CommonSmallBadge = function(_param) {
    var colorType = _param.colorType, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "colorType",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonSmallBadgeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        colorType: colorType,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
            children: children
        })
    }));
};
var CommonSmallBadgeContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CommonSmallBadge__CommonSmallBadgeContainer",
    componentId: "sc-f0846e54-0"
})(_templateObject3(), function(param) {
    var colorType = param.colorType;
    return colorType === "Disabled" && (0,styled_components_browser_esm/* css */.iv)(CommonSmallBadge_templateObject(), global_styles/* GRAY30 */.zm, global_styles/* GRAY90 */.cW, global_styles/* GRAY90 */.cW);
}, function(param) {
    var colorType = param.colorType;
    return colorType === "Fill" && (0,styled_components_browser_esm/* css */.iv)(CommonSmallBadge_templateObject1(), global_styles.BB, global_styles.BB);
}, function(param) {
    var colorType = param.colorType;
    return colorType === "Outline" && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), global_styles/* BBLight20 */.y$, global_styles/* BBLight80 */.HP);
});
var EventTagBadge = (0,styled_components_browser_esm/* default */.ZP)(global_styles/* BodyTextSStrong */.dH).withConfig({
    displayName: "CommonSmallBadge__EventTagBadge",
    componentId: "sc-f0846e54-1"
})(_templateObject4(), global_styles/* GRAY60 */.Ts, global_styles/* GRAY90 */.cW);
var PDFDownloadBadge = function(_param) {
    var colorType = _param.colorType, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "colorType",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFDownloadBadgeContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        colorType: colorType,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
            children: children
        })
    }));
};
var PDFDownloadBadgeContainer = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "CommonSmallBadge__PDFDownloadBadgeContainer",
    componentId: "sc-f0846e54-2"
})(_templateObject7(), function(param) {
    var colorType = param.colorType;
    return colorType === "Disabled" && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), global_styles/* GRAY80 */.OD, global_styles/* GRAY80 */.OD);
}, function(param) {
    var colorType = param.colorType;
    return colorType === "Outline" && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), global_styles/* BBPALE */.po, global_styles.BB, global_styles.BB);
});

// EXTERNAL MODULE: ./components/Common/GlassLoader.tsx
var GlassLoader = __webpack_require__(9702);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(2066);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(8788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5680);
// EXTERNAL MODULE: ./axiosInstance/index.ts
var axiosInstance = __webpack_require__(3213);
;// CONCATENATED MODULE: ./react-query/eventApi.ts



var getEventList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryParams) {
        var data, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axiosInstance/* eventAxiosInstance.get */.oc.get("/event", {
                            params: queryParams
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    e = _state.sent();
                    console.log(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getEventList(queryParams) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./react-query/queryClient.ts
var queryClient = __webpack_require__(2024);
;// CONCATENATED MODULE: ./react-query/eventHooks.ts







var useEventList = function() {
    var locale = (0,router.useRouter)().locale;
    var ref = (0,EventContext/* useEventContext */.Z)(), _state = ref.state, currPageNum = _state.currPageNum, pageSize = _state.pageSize, type = _state.type, search = _state.search, status = _state.status;
    // type -> all 일 경우 undefined, status -> all 일 경우 undefined, search -> 공백 검사
    var reqParams = {
        language: locale === "en" ? "eng" : "kor",
        page_size: +pageSize,
        page_num: +currPageNum,
        type: type === "all" ? undefined : type,
        status: status === "all" ? undefined : status,
        keyword: !search ? undefined : search
    };
    var query = (0,es.useInfiniteQuery)([
        queryClient/* queryKeys.eventList */.a.eventList,
        currPageNum,
        pageSize,
        type,
        search,
        status,
        locale
    ], function(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? reqParams : _pageParam;
        return getEventList(pageParam);
    }, {
        getNextPageParam: function(lastPage) {
            var totalPageNum = Math.ceil((+(lastPage === null || lastPage === void 0 ? void 0 : lastPage.all_count) || 0) / (+(lastPage === null || lastPage === void 0 ? void 0 : lastPage.page_size) || 1));
            var currentPageNum = +(lastPage === null || lastPage === void 0 ? void 0 : lastPage.page_num) || 0;
            return totalPageNum - 1 >= +currentPageNum + 1 ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reqParams), {
                page_num: +currentPageNum + 1
            }) : undefined;
        }
    });
    return query;
};

// EXTERNAL MODULE: ./components/Blog/SearchArea.tsx
var SearchArea = __webpack_require__(7277);
// EXTERNAL MODULE: ../../packages/dropdown/index.tsx + 6 modules
var dropdown = __webpack_require__(7622);
// EXTERNAL MODULE: ./components/Blog/SearchForm.tsx
var SearchForm = __webpack_require__(7454);
;// CONCATENATED MODULE: ./components/Event/EventSearchForm.tsx

function EventSearchForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EventSearchForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var EventSearchForm = function() {
    var dispatch = (0,EventContext/* useEventContext */.Z)().dispatch;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(""), searchDraft = ref[0], setSearchDraft = ref[1];
    var handleSubmit = function(e) {
        e.preventDefault();
        dispatch({
            type: "change",
            newState: {
                search: searchDraft,
                currPageNum: 0
            }
        });
    };
    var handleChange = function(e) {
        var target = e.target;
        var value = target.value;
        setSearchDraft(value);
    };
    (0,react.useEffect)(function() {
        if (searchDraft === "") dispatch({
            type: "change",
            newState: {
                search: "",
                currPageNum: 0
            }
        });
    }, [
        searchDraft,
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventSearchFormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                placeholder: locale === "en" ? "Search" : "검색어를 입력해주세요.",
                value: searchDraft,
                onChange: handleChange,
                spellCheck: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {})
            })
        ]
    });
};
/* harmony default export */ var Event_EventSearchForm = (EventSearchForm);
var EventSearchFormContainer = (0,styled_components_browser_esm/* default */.ZP)(SearchForm/* SearchFormContainer */.m).withConfig({
    displayName: "EventSearchForm__EventSearchFormContainer",
    componentId: "sc-2ca6d9c9-0"
})(EventSearchForm_templateObject());

;// CONCATENATED MODULE: ./components/Event/EventSearchArea.tsx

function EventSearchArea_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EventSearchArea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var statusItems = [
    {
        label: {
            ko: "전체",
            en: "ALL"
        },
        value: "all"
    },
    {
        label: {
            ko: "진행중",
            en: "In Progress"
        },
        value: "inprogress"
    },
    {
        label: {
            ko: "예정",
            en: "Scheduled"
        },
        value: "scheduled"
    },
    {
        label: {
            ko: "종료",
            en: "Closed"
        },
        value: "closed"
    }, 
];
var EventSearchArea = function() {
    var locale = (0,router.useRouter)().locale;
    var ref = (0,EventContext/* useEventContext */.Z)(), status = ref.state.status, dispatch = ref.dispatch;
    var currentStatusLabel = (0,react.useMemo)(function() {
        return statusItems.find(function(value) {
            return value.value === status;
        }).label[locale];
    }, [
        status,
        locale
    ]);
    var handleChangeOrder = function(e, status) {
        return dispatch({
            type: "change",
            newState: {
                status: status,
                currPageNum: 0
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventSearchAreaContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown/* Dropdown */.L, {
                disabled: false,
                changeStyle: true,
                displayBorder: false,
                onChange: handleChangeOrder,
                isPositionFixed: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* Dropdown.Toggle */.L.Toggle, {
                        style: {
                            minWidth: locale === "ko" ? "80px" : "120px"
                        },
                        children: currentStatusLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* Dropdown.OptionList */.L.OptionList, {
                        children: statusItems.map(function(statusValue) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* Dropdown.OptionItem */.L.OptionItem, {
                                selected: status === statusValue.value,
                                disabled: status === statusValue.value,
                                value: statusValue.value,
                                label: statusValue.label[locale],
                                tabIndex: -1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchArea/* OrderByOptionItemButton */.IJ, {
                                    children: statusValue.label[locale]
                                })
                            }, statusValue.value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_EventSearchForm, {})
        ]
    });
};
/* harmony default export */ var Event_EventSearchArea = (EventSearchArea);
var EventSearchAreaContainer = (0,styled_components_browser_esm/* default */.ZP)(SearchArea/* SearchAreaContainer */.XP).withConfig({
    displayName: "EventSearchArea__EventSearchAreaContainer",
    componentId: "sc-822e2046-0"
})(EventSearchArea_templateObject());

;// CONCATENATED MODULE: ./components/Event/EventListSection.tsx

function EventListSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n\n  .target-img {\n    object-fit: contain;\n    background: #000;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    transition: transform 0.2s ease-in;\n  }\n  .event-card-list {\n    width: 100%;\n  }\n  .event-card {\n    width: 100%;\n    position: relative;\n    padding: 28px;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);\n    display: flex;\n    align-items: center;\n  }\n  .event-card:hover .target-img {\n    transform: scale(1.05);\n  }\n  .m-c + .m-c {\n    margin-top: 32px;\n  }\n  .left-wrapper {\n    overflow: hidden;\n    position: relative;\n    width: 360px;\n    height: 240px;\n    flex-shrink: 0;\n  }\n  .right-wrapper {\n    width: 100%;\n    margin-left: 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n  }\n  .ev-type {\n    color: ",
        ";\n    margin-bottom: 0.4rem;\n  }\n  .ev-t {\n    display: flex;\n    align-items: center;\n  }\n  .ev-t-t {\n    margin-right: 1rem;\n    font-size: 20px;\n  }\n  .ev-loc {\n    color: ",
        ";\n  }\n  .loc-wrapper {\n    margin: 1.6rem 0;\n  }\n  .ev-b-loc {\n    color: ",
        ";\n  }\n  .ev-d-r {\n    color: ",
        ";\n  }\n  .tags-wrapper {\n    display: flex;\n    margin-top: 16px;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n  .ev-description-area {\n    color: ",
        ";\n    margin-top: 24px;\n    white-space: pre-wrap;\n  }\n  @media screen and (max-width: 768px) {\n    .event-card {\n      flex-direction: column;\n    }\n    .left-wrapper {\n      width: 100%;\n      padding-top: 66.67%;\n    }\n    .right-wrapper {\n      margin-top: 31px;\n      margin-left: 0;\n    }\n  }\n"
    ]);
    EventListSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventListSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #000;\n  &:active {\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2) !important;\n  }\n  &:hover {\n    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.3) !important;\n  }\n"
    ]);
    EventListSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var typeLabels = {
    en: {
        international: "International Exhibition",
        domestic: "Domestic Exhibition"
    },
    ko: {
        international: "해외전시",
        domestic: "국내전시"
    }
};
var EventListSection = function() {
    var ref;
    var locale = (0,router.useRouter)().locale;
    var ref1 = useEventList(), eventListRes = ref1.data, isLoading = ref1.isLoading, hasNextPage = ref1.hasNextPage, fetchNextPage = ref1.fetchNextPage, isFetchingNextPage = ref1.isFetchingNextPage;
    var ref2 = (0,EventContext/* useEventContext */.Z)(), prevScrollTop = ref2.state.prevScrollTop, dispatch = ref2.dispatch;
    var noEvents = (0,react.useMemo)(function() {
        if (isLoading) return false;
        var flatPosts = eventListRes === null || eventListRes === void 0 ? void 0 : eventListRes.pages.map(function(page) {
            return page === null || page === void 0 ? void 0 : page.events;
        }).flat().flat();
        return !flatPosts || flatPosts.length === 0;
    }, [
        eventListRes,
        isLoading
    ]);
    (0,react.useEffect)(function() {
        if (prevScrollTop) window.scrollTo({
            top: prevScrollTop
        });
        dispatch({
            type: "change",
            newState: {
                prevScrollTop: 0
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        dispatch({
            type: "change",
            newState: {
                currPageNum: 0
            }
        });
    }, [
        locale,
        dispatch
    ]);
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListSectionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlassLoader/* GlassLoader */.y, {
            loadingText: "Loading events..."
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventListSectionContainer, {
        children: [
            noEvents ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoPost/* default */.Z, {
                text: {
                    en: "Matched result not found.",
                    ko: "검색 결과에 해당하는 이벤트가 없습니다."
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "event-card-list",
                children: eventListRes === null || eventListRes === void 0 ? void 0 : (ref = eventListRes.pages) === null || ref === void 0 ? void 0 : ref.map(function(eventList) {
                    var ref;
                    return eventList === null || eventList === void 0 ? void 0 : (ref = eventList.events) === null || ref === void 0 ? void 0 : ref.map(function(event) {
                        var ref, ref1, ref2, ref3;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "m-c",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalHrefProvider, {
                                href: event.status !== "closed" ? event.event_link || undefined : undefined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "left-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            draggable: false,
                                            src: event.thumbnail_url || "",
                                            className: "target-img",
                                            alt: "".concat(event.title || "", " image")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "right-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
                                                className: "ev-type",
                                                children: typeLabels[locale][event.type] || "-"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ev-t",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                                                        className: "ev-t-t",
                                                        children: event.title || "-"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonSmallBadge, {
                                                        colorType: event.status === "inprogress" ? "Fill" : event.status === "scheduled" ? "Outline" : "Disabled",
                                                        children: (ref = statusItems.find(function(item) {
                                                            return item.value === event.status;
                                                        })) === null || ref === void 0 ? void 0 : ref.label[locale]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFDownloadBadge, {
                                                        style: {
                                                            marginLeft: "4px"
                                                        },
                                                        colorType: event.has_pdf ? "Outline" : "Disabled",
                                                        onClickCapture: function(e) {
                                                            e.stopPropagation();
                                                            if (!event.has_pdf) return;
                                                            var $a = document.createElement("a");
                                                            console.log(event);
                                                            $a.href = event.pdf_url;
                                                            $a.target = "_blank";
                                                            $a.click();
                                                            $a.remove();
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                alignContent: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PdfDownaloadIcon */.ty, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        marginLeft: "4px"
                                                                    },
                                                                    children: locale === "ko" ? "제품 소개" : "Product Info"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "loc-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
                                                        className: "ev-loc",
                                                        as: "div",
                                                        children: event.location || ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextSStrong */.dH, {
                                                        className: "ev-b-loc",
                                                        as: "div",
                                                        children: event.booth_location || ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(global_styles/* BodyTextS */.Ei, {
                                                className: "ev-d-r",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref1 = event.start_time) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 10)) || "-"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: " ~ "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: ((ref2 = event.end_time) === null || ref2 === void 0 ? void 0 : ref2.slice(0, 10)) || "-"
                                                    })
                                                ]
                                            }),
                                            event.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* BodyTextS */.Ei, {
                                                className: "ev-description-area",
                                                as: "pre",
                                                children: event.description
                                            }),
                                            event.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tags-wrapper",
                                                children: (ref3 = event.tags) === null || ref3 === void 0 ? void 0 : ref3.split("#").map(function(tag) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventTagBadge, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "#"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: tag
                                                            })
                                                        ]
                                                    }, tag);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, event.eid);
                    });
                })
            }),
            !noEvents && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainButton/* MainButton */.c, {
                className: "p-b-btn",
                buttonType: isFetchingNextPage || !hasNextPage ? "disabled" : "default",
                text: isFetchingNextPage ? locale === "en" ? "Loading..." : "로드중..." : hasNextPage ? locale === "en" ? "Load next" : "더 보기" : locale === "en" ? "You are on the last page." : "마지막 페이지 입니다.",
                injectInlineStyles: {
                    height: "48px",
                    marginTop: "56px"
                },
                injectCssStyles: [
                    (0,breakPoints/* generateCssStyle */.m)({
                        width: hasNextPage ? "156px" : "fit-content",
                        padding: hasNextPage ? "0" : "0 32px"
                    }), 
                ],
                onClick: function() {
                    return fetchNextPage();
                }
            })
        ]
    });
};
/* harmony default export */ var Event_EventListSection = (EventListSection);
var EventListSectionContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "EventListSection__EventListSectionContainer",
    componentId: "sc-b057bb60-0"
})(EventListSection_templateObject(), global_styles.BB, global_styles/* GRAY40 */.vm, global_styles/* GRAY40 */.vm, global_styles/* GRAY60 */.Ts, global_styles/* GRAY60 */.Ts);
var ConditionalHrefProvider = function(param) {
    var href = param.href, children = param.children;
    if (href) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalHrefAnchor, {
        className: "event-card",
        target: "_blank",
        href: href.includes("https://") ? href : "https://".concat(href),
        style: {
            display: "flex"
        },
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "event-card",
        children: children
    });
};
var ConditionalHrefAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    displayName: "EventListSection__ConditionalHrefAnchor",
    componentId: "sc-b057bb60-1"
})(EventListSection_templateObject1());

;// CONCATENATED MODULE: ./components/Event/EventMainSection.tsx

function EventMainSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    EventMainSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var EventMainSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventMainSectionContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inner-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_EventCategoryTab, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_EventSearchArea, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_EventListSection, {})
            ]
        })
    });
};
/* harmony default export */ var Event_EventMainSection = (EventMainSection);
var EventMainSectionContainer = (0,styled_components_browser_esm/* default */.ZP)(BlogMainSection/* BlogMainSectionContainer */.w).withConfig({
    displayName: "EventMainSection__EventMainSectionContainer",
    componentId: "sc-4afc9f33-0"
})(EventMainSection_templateObject());

;// CONCATENATED MODULE: ./pages/event/index.tsx


function event_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    event_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var Index = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_modern/* useInView */.YD)({
        fallbackInView: true
    }), 3), $fakeHeaderRef = ref[0], isFakeHeaderVisible = ref[1], fakeHeaderEntry = ref[2];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventMainContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Event - BLUEDOT",
                description: "블루닷의 기술을 현장에서 직접 만나보세요.",
                canonical: "https://blue-dot.io/event/",
                openGraph: {
                    url: "https://blue-dot.io/event/",
                    title: "Event - BLUEDOT",
                    description: "블루닷의 기술을 현장에서 직접 만나보세요.",
                    images: [
                        {
                            url: bluedot_metatag_img/* default.src */.Z.src,
                            alt: "BLUEDOT INC.",
                            type: "image/png"
                        }, 
                    ],
                    siteName: "BLUEDOT"
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Global/* BypassBlock */.ok, {
                contentSectionId: "#blog-content1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "io-target",
                ref: $fakeHeaderRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeader/* default */.Z, {
                isScrolled: !isFakeHeaderVisible && !!(fakeHeaderEntry === null || fakeHeaderEntry === void 0 ? void 0 : fakeHeaderEntry.target)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonMainVisual, {
                backgroundImageSrc: blog_main_visual/* default.src */.Z.src,
                innerContainerTitle: {
                    en: "Event",
                    ko: "Event"
                },
                descriptionTextComponent: {
                    en: /*#__PURE__*/ (0,jsx_runtime.jsx)(EN, {}),
                    ko: /*#__PURE__*/ (0,jsx_runtime.jsx)(KO, {})
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Event_EventMainSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About/* AboutCheckoutProduct */.yz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingController/* default */.Z, {
                isVisible: isFakeHeaderVisible
            })
        ]
    });
};
/* harmony default export */ var pages_event = (Index);
var EventMainContainer = (0,styled_components_browser_esm/* default */.ZP)(CommonWrappers/* PageOuterContainer */.px).withConfig({
    displayName: "event__EventMainContainer",
    componentId: "sc-2232efc6-0"
})(event_templateObject());
var KO = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ko-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "블루닷의 기술을 현장에서 직접 만나보세요."
            })
        })
    });
};
var EN = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "en-wrapper-pc",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Meet BLUEDOT's technology on the spot."
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "en-wrapper-mo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_styles/* SubtitleM */.sy, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Meet BLUEDOT's technology on the spot."
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [726,769,351,605,572,352,710,266,774,888,179], function() { return __webpack_exec__(8587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);